// Insphirea chrome: scroll reveals + dispatch countdown.
(function () {
  const els = [...document.querySelectorAll(".ins-reveal")];
  if (els.length) {
    if (!("IntersectionObserver" in window)) { els.forEach((e) => e.classList.add("in")); }
    else {
      const io = new IntersectionObserver(
        (ents) => ents.forEach((en) => { if (en.isIntersecting) { en.target.classList.add("in"); io.unobserve(en.target); } }),
        { threshold: 0.12, rootMargin: "0px 0px -8% 0px" }
      );
      els.forEach((e) => io.observe(e));
    }
  }

  // Dispatch line, always in Amsterdam time: Monday to Friday before 13:00 ships
  // today; later, and at weekends, it names the next working day. Dates in
  // NO_DISPATCH (YYYY-MM-DD, Amsterdam) are skipped like a weekend.
  const el = document.querySelector("[data-ins-cutoff]");
  if (el) {
    // Dutch public holidays without dispatch (Gio, 16 Oct 2026): Kerst, Nieuwjaar,
    // 2e Paasdag, Koningsdag, Hemelvaart, 2e Pinksterdag. Extend each autumn.
    const NO_DISPATCH = ["2026-12-25", "2027-01-01", "2027-03-29", "2027-04-27", "2027-05-06", "2027-05-17"];
    const CUTOFF_MIN = 13 * 60;
    const en = (document.documentElement.lang || "").toLowerCase().startsWith("en");
    const fmt = new Intl.DateTimeFormat("en-GB", { timeZone: "Europe/Amsterdam", year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", weekday: "short", hourCycle: "h23" });
    const DAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const NAMES = en
      ? ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
      : ["zondag", "maandag", "dinsdag", "woensdag", "donderdag", "vrijdag", "zaterdag"];
    const ams = (d) => {
      const p = {}; fmt.formatToParts(d).forEach((x) => { p[x.type] = x.value; });
      return { ymd: p.year + "-" + p.month + "-" + p.day, dow: DAYS.indexOf(p.weekday), min: +p.hour * 60 + +p.minute };
    };
    const ships = (a) => a.dow > 0 && a.dow < 6 && NO_DISPATCH.indexOf(a.ymd) < 0;
    const tick = () => {
      const T = (window.INS_I18N && window.INS_I18N.announce) || {};
      const now = new Date(), a = ams(now);
      if (ships(a) && a.min < CUTOFF_MIN) {
        const left = CUTOFF_MIN - a.min, h = Math.floor(left / 60), m = left % 60;
        const tmpl = T.countdown || "Nog [h]u [m]m voor verzending vandaag";
        el.textContent = tmpl.replace("[h]", h).replace("[m]", m);
        return;
      }
      const ymd = a.ymd.split("-").map(Number);
      const day = (k) => { const d = new Date(Date.UTC(ymd[0], ymd[1] - 1, ymd[2] + k)); return { ymd: d.toISOString().slice(0, 10), dow: d.getUTCDay() }; };
      let n = 1, next = day(1);
      while (!ships(next) && n < 14) { n += 1; next = day(n); }
      if (n === 1 && ships(a)) { el.textContent = T.ordered_shipped || "Vandaag besteld, morgen verzonden"; return; }
      el.textContent = en ? "Order today, ships " + NAMES[next.dow] : "Vandaag besteld, " + NAMES[next.dow] + " verzonden";
    };
    tick(); setInterval(tick, 60000);
  }
})();

// Prefetch product/collection pages on intent (hover/touchstart) so navigation
// feels near-instant. Low-priority, deduped, same-origin only. Pairs with the
// CSS view-transition for a smooth, flash-free page change. Respects Save-Data.
(function () {
  if (navigator.connection && navigator.connection.saveData) return;
  const seen = new Set();
  function prefetch(href) {
    if (seen.has(href)) return;
    seen.add(href);
    const l = document.createElement("link");
    l.rel = "prefetch";
    l.href = href;
    document.head.appendChild(l);
  }
  function onIntent(e) {
    const a = e.target.closest && e.target.closest('a[href]');
    if (!a) return;
    let u;
    try { u = new URL(a.href, location.href); } catch (_) { return; }
    if (u.origin === location.origin && /\/(products|collections)\//.test(u.pathname)) prefetch(u.href);
  }
  document.addEventListener("mouseover", onIntent, { passive: true });
  document.addEventListener("touchstart", onIntent, { passive: true });
})();

// Cart drawer: swipe-down to dismiss on mobile (native bottom-sheet feel).
(function () {
  const drawer = document.querySelector("cart-drawer");
  if (!drawer) return;
  const isMobile = () => window.matchMedia("(max-width: 749px)").matches;
  function bind() {
    const panel = drawer.querySelector(".drawer__inner");
    if (!panel || panel.dataset.swipeBound) return;
    panel.dataset.swipeBound = "1";
    let startY = 0, curY = 0, dragging = false;
    panel.addEventListener("touchstart", (e) => {
      if (!isMobile()) return;
      const sc = panel.querySelector(".drawer__contents, .cart-drawer-items, #CartDrawer-CartItems") || panel;
      if (sc.scrollTop > 0) return;
      startY = curY = e.touches[0].clientY; dragging = true; panel.style.transition = "none";
    }, { passive: true });
    panel.addEventListener("touchmove", (e) => {
      if (!dragging) return;
      curY = e.touches[0].clientY;
      panel.style.transform = "translateY(" + Math.max(0, curY - startY) + "px)";
    }, { passive: true });
    panel.addEventListener("touchend", () => {
      if (!dragging) return;
      dragging = false; panel.style.transition = ""; panel.style.transform = "";
      if (curY - startY > 110 && typeof drawer.close === "function") drawer.close();
    });
  }
  bind();
  // re-bind if Dawn re-renders the drawer contents
  new MutationObserver(bind).observe(drawer, { childList: true, subtree: true });
})();
